import { render, staticRenderFns } from "./CurrencyInput.vue?vue&type=template&id=b9128bb4&"
import script from "./CurrencyInput.vue?vue&type=script&lang=js&"
export * from "./CurrencyInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports